import { filter, groupBy, map, sortBy, uniq } from 'lodash'

import config from '@/config'

import normalizeRadioTransmission from '../../util/normalizeRadioTransmission'

const maxFrequency = config.maxRadioTransmissionFrequency
const minFrequency = config.minRadioTransmissionFrequency

const resetRadioTransmittions = (state) => {
  state.radioTransmissions = []

  return state
}

export default {

  state: resetRadioTransmittions({}),

  getters: {

    radioTransmissions ({ radioTransmissions }) {
      return sortBy(radioTransmissions, 'frequency')
    },

    radioTransmissionIndexesById (state, getters) {
      const indexes = {}

      getters.radioTransmissions.forEach((radioTransmission, i) => {
        indexes[radioTransmission.id] = i
      })

      return indexes
    },

    radioTransmissionIndexesByFrequency (state, getters) {
      const indexes = {}

      getters.radioTransmissions.forEach((radioTransmission, i) => {
        indexes[radioTransmission.frequency] = i
      })

      return indexes
    },

    radioTransmissionFrequencies (state, getters) {
      return uniq(map(getters.radioTransmissions, 'frequency'))
    },

    radioTransmissionById (state, getters) {
      return (id) => {
        return getters.radioTransmissions[getters.radioTransmissionIndexesById[id]]
      }
    },

    radioTransmissionByRadioId (state, getters) {
      return groupBy(getters.radioTransmissions, 'radioId')
    },

    radioTransmissionsOfRadioId (state, getters) {
      return (radioId) => {
        return getters.radioTransmissionByRadioId[radioId]
      }
    },

    radioTransmissionOnFrequency (state, getters) {
      return (frequency) => {
        return getters.radioTransmissions[getters.radioTransmissionIndexesByFrequency[frequency]]
      }
    },

    radioTransmissionInFrequencyRange (state, getters) {
      return (min, max) => {
        return filter(getters.radioTransmissions, (radioTransmission) => {
          return radioTransmission.frequency >= Math.max(min, minFrequency) && radioTransmission.frequency <= Math.min(max, maxFrequency)
        })
      }
    }

  },

  mutations: {

    resetRadioTransmittions,

    createRadioTransmission (state, radioTransmission) {
      state.radioTransmissions.push(normalizeRadioTransmission(radioTransmission))
    },

    deleteRadioTransmission (state, i) {
      if (state.radioTransmissions[i]) {
        state.radioTransmissions.splice(i, 1)
      }
    }

  },

  actions: {

    startRadioTransmission ({ commit }, radioTransmission) {
      commit('createRadioTransmission', radioTransmission)
    },

    endRadioTransmissionById ({ commit, getters }, id) {
      if (getters.radioTransmissionIndexesById[id] || getters.radioTransmissionIndexesById[id] === 0) {
        commit('deleteRadioTransmission', getters.radioTransmissionIndexesById[id])
      }
    }

  }

}
